import React from 'react'
import { FormLabels, CustomText } from 'src/components'
import { useAppSelector } from 'src/app/hooks'
import { VintageItemPayload } from 'src/core/models'
import { getDateFormattedSmall, getFormatedPrice, getProjectUnit } from 'src/core/helpers'
import { projectCurrencyTokenCodeSelected, projectFormStateSelector } from 'src/features'

const VintageColumnMovile: React.FC<{vintage: VintageItemPayload}> = ({ vintage }) => {
  const currencyCode = useAppSelector(projectCurrencyTokenCodeSelected)
  const { kind } = useAppSelector(projectFormStateSelector)
  const price = getFormatedPrice(vintage.price, currencyCode)

  return <>
    <FormLabels
      title={`${vintage.year}`}
      subtitle={`${price}`}
      thirdLabel={`${vintage.stock} ${getProjectUnit(kind)}`}
    />
    {kind === 'carbon_forward' && (
      <CustomText label={getDateFormattedSmall(vintage.delivery_date)}/>
    )}
  </>
}

export default VintageColumnMovile
